import {
  CheckCircleOutlined,
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { Button, Flex, Input, Space, Typography } from 'antd';
import { FC } from 'react';
import {
  Control,
  FieldArrayWithId,
  get,
  useFormContext,
} from 'react-hook-form';

import { FormItem } from './FormItem';

const { Text } = Typography;

const MAX_BENEFITS = 5;

interface BenefitsListProps {
  control: Control<any>;
  fields: FieldArrayWithId[];
  append: (value: string) => void;
  remove: (index: number) => void;
}

export const BenefitsList: FC<BenefitsListProps> = ({
  control,
  fields,
  append,
  remove,
}) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Flex justify='flex-end' style={{ marginBottom: 8 }}>
        <Button
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => append('')}
          disabled={fields.length >= MAX_BENEFITS}
        >
          Adicionar benefício
        </Button>
      </Flex>

      {fields.length === 0 ? (
        <EmptyState
          title='Nenhum benefício adicionado'
          description='Clique em "Adicionar Benefício" para começar'
        />
      ) : (
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          {fields.map((field, index) => (
            <Flex key={field.id} gap={8} align='start'>
              <CheckCircleOutlined
                style={{
                  color: '#1668DC',
                  fontSize: 18,
                  flexShrink: 0,
                  marginTop: 8,
                }}
              />
              <FormItem
                control={control}
                name={`content.benefits.${index}`}
                renderItem={({ field: inputField }: any) => (
                  <Input
                    {...inputField}
                    placeholder='Descreva o benefício...'
                    maxLength={130}
                    showCount
                    status={
                      get(errors, `content.benefits.${index}`)
                        ? 'error'
                        : undefined
                    }
                  />
                )}
              />
              <Button
                type='text'
                danger
                icon={<DeleteOutlined />}
                onClick={() => remove(index)}
                style={{ flexShrink: 0, marginTop: 2 }}
              />
            </Flex>
          ))}
        </Space>
      )}
    </>
  );
};

interface EmptyStateProps {
  title: string;
  description: string;
}

export const EmptyState: FC<EmptyStateProps> = ({ title, description }) => (
  <Flex
    vertical
    align='center'
    justify='center'
    style={{
      padding: 32,
      background: '#FFFFFF14',
      borderRadius: 8,
      border: '1px solid #424242',
    }}
  >
    <Text strong>{title}</Text>
    <Text type='secondary'>{description}</Text>
  </Flex>
);
